import { Injectable } from '@angular/core';
import {
  adobeClickEventAnalyticsMocks,
  ANALYTICS_EVENTS,
  AnalyticsService,
  ClickEventAnalytics,
  EVENT_CLICK_TYPE,
  HEADER_MENU,
  HEADER_TOP_MENU,
  PageLoadAnalytics,
  USER_LOGGED_IN_STATUS
} from '@com-delta-idp/mnx-utils';
import { AccountSummaryService } from '../accountsummary/account-summary.service';

@Injectable({
  providedIn: 'root'
})
export class AdobeDataLayerService {
  constructor(
    private analytics: AnalyticsService,
    private accountSummary: AccountSummaryService
  ) {}

  setUserDataInAnalytics(data: ClickEventAnalytics | PageLoadAnalytics): void {
    this.accountSummary.getAccountSummaryDetails().subscribe((userStatus) => {
      data = {
        ...data,
        ...{
          user: {
            attributes: {
              is_logged_in: userStatus?.loggedIn
                ? USER_LOGGED_IN_STATUS.AUTHENTICATED
                : USER_LOGGED_IN_STATUS.UNAUTHENTICATED
            }
          }
        }
      };
      this.analytics.setAnalytics(data);
    });
  }

  updateAnalytics(url: string, navItem: string, subNavItem = ''): void {
    let headerMenu: Record<string, string> = {};
    if (subNavItem !== '') {
      headerMenu = HEADER_MENU[navItem][subNavItem];
    } else {
      headerMenu = HEADER_MENU[navItem];
    }
    const { NAME, PAGE_SECTION } = headerMenu;
    let data = adobeClickEventAnalyticsMocks;
    data = {
      ...data,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: ANALYTICS_EVENTS.CLICK,
      click: {
        name: NAME,
        type: EVENT_CLICK_TYPE.BUTTON,
        page_section: PAGE_SECTION,
        action: url
      }
    };
    this.setUserDataInAnalytics(data);
  }

  appNavLinksAnalytics(
    navItem: string,
    secondaryNav: string,
    url: string
  ): void {
    const menus = {
      secondarynav: HEADER_TOP_MENU.TRAVEL_INFO,
      'sky-miles': HEADER_TOP_MENU.SKYMILES,
      more: HEADER_TOP_MENU.NEED_HELP
    };
    let data = adobeClickEventAnalyticsMocks;
    const { NAME, PAGE_SECTION } = HEADER_MENU[menus[navItem]];
    data = {
      ...data,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: ANALYTICS_EVENTS.CLICK,
      click: {
        name: NAME,
        type: EVENT_CLICK_TYPE.LINK,
        page_section: `${PAGE_SECTION}:${secondaryNav}`,
        action: url
      }
    };
    this.setUserDataInAnalytics(data);
  }
}
